/**
 * Scans (360) Panel Store Module (AVA-597)
 *
 * Remembers the Scans panel's filters, search, sort and collapsed state while the panel is closed
 * and reopened. The state belongs to one facility: images360Tab.vue commits RESET_FOR_FACILITY when
 * the facility changes. `filters: null` means "not initialised"; the panel fills it from
 * scanFilters.createDefaultFilters once it knows the tree depth.
 *
 * Registration: src/store/index.js as 'SCANS_PANEL'.
 */

const DEFAULT_SORT_BY = 'name';

/** Fresh default state; also the reset target, so defaults live in one place. */
export function createScansPanelState() {
  return {
    facilityId: null,
    filters: null,
    search: '',
    sortBy: DEFAULT_SORT_BY,
    sortAscending: true,
    filtersCollapsed: false,
  };
}

export const SCANS_PANEL = {
  namespaced: true,

  state: createScansPanelState,

  mutations: {
    /** Replace the filter object; callers build it immutably with scanFilters.withFilter. */
    SET_FILTERS(state, filters) {
      state.filters = filters;
    },
    SET_SEARCH(state, search) {
      state.search = search;
    },
    SET_SORT(state, { sortBy, sortAscending }) {
      state.sortBy = sortBy;
      state.sortAscending = sortAscending;
    },
    SET_FILTERS_COLLAPSED(state, collapsed) {
      state.filtersCollapsed = collapsed;
    },
    /** A different facility shares no tier values with the old one: start over, remembering the new id. */
    RESET_FOR_FACILITY(state, facilityId) {
      Object.assign(state, createScansPanelState(), { facilityId });
    },
  },
};
